import { black } from '../const/colors'
import {
  MENU_BAR,
  MENU_BAR_ACCOUNT_LABEL,
  MENU_BAR_ACCOUNT_NAME,
  MENU_BAR_ICON,
  MENU_BAR_INFO_ACCOUNT_NAME,
  MENU_BAR_INFO_USER_NAME,
  MENU_BAR_LIST_LINK,
  MENU_BAR_LIST_LINK_ACTIVE,
  MENU_BAR_LIST_LINK_CONTENT
} from './getDefaultTheme'

const menuBarBackgroundColor = '#BA9863'
const menuBarIconColor = '#F8F4EF'
const menuBarTextColor = '#F8F4EF'

export const getAlulaXiTheme = defaultTheme => ({
  // the AlulaXI should fallback to default theme and adjust menu bar colors/sizes only
  ...defaultTheme,
  [MENU_BAR]: {
    backgroundColor: menuBarBackgroundColor
  },
  [MENU_BAR_ACCOUNT_NAME]: {
    color: menuBarTextColor,
    fontSize: 20
  },
  [MENU_BAR_ACCOUNT_LABEL]: {
    color: menuBarTextColor
  },
  [MENU_BAR_INFO_USER_NAME]: {
    color: menuBarTextColor
  },
  [MENU_BAR_INFO_ACCOUNT_NAME]: {
    color: menuBarTextColor
  },
  [MENU_BAR_LIST_LINK]: {
    backgroundColor: 'transparent',
    fontWeight: 'bold',
    fontSize: 20,
    color: menuBarTextColor
  },
  [MENU_BAR_LIST_LINK_ACTIVE]: {
    color: black
  },
  [MENU_BAR_LIST_LINK_CONTENT]: {
    padding: '2px 8px',
    minHeight: 24
  },
  [MENU_BAR_ICON]: {
    color: menuBarIconColor
  }
})
